export function useUrlFilterCount(keys: () => readonly string[]) {
  const route = useRoute();
  return computed(() => {
    let count = 0;
    for (const key of keys()) {
      const raw = route.query[key];
      if (Array.isArray(raw)) {
        if (raw.some((v) => typeof v === "string" && v.length)) count++;
      } else if (typeof raw === "string" && raw.length) {
        count++;
      }
    }
    return count;
  });
}
